export { getDateViolations } from './segment-date-change-violations';

export const hasNewCoApplicant = (initialPeople, people) => {
  const initialCoapp = initialPeople?.find((p) => p.isCoApplicant);
  const newCoApp = people?.find((p) => p.isCoApplicant);

  const samePerson =
    initialCoapp?.firstName?.trim() === newCoApp?.firstName?.trim() &&
    initialCoapp?.lastName?.trim() === newCoApp?.lastName?.trim() &&
    initialCoapp?.dateOfBirth === newCoApp?.dateOfBirth;

  const newCoAppAdded = (!initialCoapp && newCoApp) || (newCoApp && !samePerson);

  return newCoAppAdded;
};
